import noImage from '../../images/no-image-placeholder-6f3882e0.webp';

const getImageUrl = (url) => {
  if (!url) return noImage;
  return url;
};

export default getImageUrl;
